import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import { getUserSettings } from 'actions/user';
import MaxBookings from 'organisms/DrawerContent/Settings/MaxBookings';
import AvailabilityLoader from 'organisms/Loaders/AvailabilityLoader';
import GeneralLoader from 'organisms/Loaders/GeneralLoader';
import { clearForm, initializeForm } from 'store/reducers/groomerForm';

import Details from '../GroomerCreate/Details';
import Services from '../GroomerCreate/Services';
import Header from './Header';
import ResetPassword from './ResetPassword';
import UserDetails from './UserDetails';
import UserServices from './UserServices';

export const defaultService = [{ uuid: uuidv4() }];

export default function GroomerEdit({ onSave, saveImage }) {
  const dispatch = useDispatch();
  const { uuid } = useSelector((state) => state.ui.drawer);
  const { groomers, isLoading } = useSelector((state) => state.groomers);
  const settings = useSelector((state) => state.entitySettings);
  const selectedGroomer = groomers.filter(
    (groomer) => groomer.user.uuid === uuid
  )?.[0];
  const [mode, setMode] = useState('preview');

  useEffect(() => {
    dispatch(initializeForm(selectedGroomer));
    dispatch(getUserSettings({ uuid }));
    return () => dispatch(clearForm());
  }, []);

  if (isLoading)
    return (
      <div className="payment-drawer flex-column align-end">
        <div className="w-100">
          <Header
            setMode={setMode}
            isEditing={mode === 'edit'}
            onSave={onSave}
          />
          <GeneralLoader />;
        </div>
      </div>
    );

  return (
    <div className="payment-drawer flex-column align-end">
      <div className="w-100">
        <Header setMode={setMode} isEditing={mode === 'edit'} onSave={onSave} />
        {mode === 'edit' ? (
          <>
            <Details saveImage={saveImage} />
            <Services />
          </>
        ) : (
          <>
            <UserDetails data={selectedGroomer} />
            <UserServices data={selectedGroomer} />
            <ResetPassword data={selectedGroomer} />
            <MaxBookings maxConcurrency={settings.maxConcurrency} uuid={uuid} />
          </>
        )}
      </div>
    </div>
  );
}
